onComplete(function () {
	const header = document.querySelector('header.nav-header');
	const screenWidth = window.innerWidth;
	let prevScrollPos;
	let currentScrollPos = document.documentElement.scrollTop;
	window.addEventListener('scroll', function () {
		if (screenWidth > 768) {
			currentScrollPos = document.documentElement.scrollTop;
			if (prevScrollPos > currentScrollPos || prevScrollPos <= 0) {
				header.style.translate = "0 0";
			} else {
				header.style.translate = "0 -100%";
			}
			prevScrollPos = currentScrollPos;
		}
	});
});